// extracted by mini-css-extract-plugin
export default {"warning":"AddNewProvider_warning__H3vx4","cancel":"AddNewProvider_cancel__aGYHK","form_button":"AddNewProvider_form_button__xVHR3"};